export default function CtaSection() {
  return (
    <section className="w-full px-4 py-14 md:px-6 md:py-20">
      <div className="relative flex min-h-[420px] items-center overflow-hidden rounded-xl border border-background-200 md:min-h-[440px]">
        <img
          src="https://readdy.ai/api/search-image?query=Stylized%20warm%20textured%20paper%20desk%20surface%20with%20subtle%20pinned%20photographs%20and%20soft%20amber%20light%2C%20minimal%20editorial%20background%2C%20muted%20sepia%20tones%2C%20high%20detail%2C%20clean%20composition&width=1600&height=640&seq=hl-cta-desk-01&orientation=landscape"
          alt="黑料照片 证据素材 检索入口 背景"
          title="黑料照片 · 检索入口"
          className="absolute inset-0 h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/80 via-foreground-950/60 to-foreground-950/30" />

        <div className="relative flex w-full flex-col gap-6 px-6 py-12 md:px-12 md:py-16 lg:max-w-3xl">
          <span className="inline-flex w-fit items-center gap-2 rounded-full bg-background-50/15 px-3 py-1.5 font-label text-xs text-background-50 backdrop-blur">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-bookmark-3-line text-sm" />
            </span>
            资源入口 · 持续归档
          </span>
          <h3 className="font-heading text-3xl font-black leading-tight text-background-50 md:text-4xl">
            先按事件名检索，再对照时间线判断
          </h3>
          <p className="max-w-xl text-sm leading-7 text-background-100 md:text-base">
            无论是找某件事的实锤图，还是需要聊天截图、同框照、定位与时间戳的佐证素材，
            都从检索框开始。每条记录都带着来源与关联事件，方便你逐项核对。
          </p>
          <div className="flex flex-col gap-3 sm:flex-row">
            <a
              href="#archive"
              className="cursor-pointer whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-center text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:text-base"
            >
              进入证据汇总
            </a>
            <a
              href="#timeline"
              className="cursor-pointer whitespace-nowrap rounded-full border border-background-50/50 px-6 py-3 text-center text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10 md:text-base"
            >
              查看时间线核对
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}